import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchSubscriptionHistory, fetchGiftHistory, fetchTransactionHistory, fetchCoinHistory } from "./service";
import Translate, { useTranslateText } from "../../../Components/Multilanguage/Translate";
import { getUpdatePaymentLink } from "../../../network/service";
import { ReactComponent as CopyIcon } from "../../../assets/Icons/copy.svg";
import { ReactComponent as TickIcon } from "../../../assets/Icons/tick.svg";
import Loading from "../../../Components/Loading/Loading";

const BillingDetails = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const [subscriptionHistory, setSubscriptionHistory] = useState({});
  const [giftHistory, setGiftHistory] = useState({});
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [coinHistory, setCoinHistory] = useState([]);
  const [expiryDate, setExpiryDate] = useState("");
  const [activeTab, setActiveTab] = useState("subscription");
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const translateText = useTranslateText();

  const navigate = useNavigate();
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  const loadBillingData = async () => {
    setLoading(true);
    await Promise.allSettled([
      getSubscriptionHistory(),
      getGiftHistory(),
      getPurchaseHistory(),
      getEpisodePurchaseHistory(),
    ]);
    setLoading(false);
  };
  useEffect(() => {
    window.scroll(0, 0);
    loadBillingData();
  }, []);

  const handleCopy = (code, idx) => {
    if (code) {
      const url = `${window.location.origin}/gift/claim?gc=${code}`;
      navigator.clipboard.writeText(url);
      setCopiedIndex(idx);
      setTimeout(() => setCopiedIndex(null), 1600);
    }
  };

  const getSubscriptionHistory = async () => {
    try {
      const response = await fetchSubscriptionHistory(appInfo);
        if(response?.data?.purchase_history?.length > 0) {
          setActiveTab("subscription");
        } else {
          setActiveTab("purchase_history");
        }
      if (response?.status === 200) {
        setSubscriptionHistory(response?.data);    
        const date = new Date(response?.data?.last_purchase?.valid_to);
        const subscription_type = response?.data?.last_purchase?.subscription_type;

        if (subscription_type !== 1 && subscription_type !== 2) {
          const nextday = new Date(response?.data?.last_purchase?.valid_to);
          nextday.setDate(date.getDate() + 1);
          setExpiryDate(nextday.toDateString());
        }

      }
    } catch (err) { }
  };
  const getPurchaseHistory = async () => {
      try {
        const response = await fetchTransactionHistory(appInfo);
        if (response?.status === 200) {
          // Handle transaction history data if needed
          setPurchaseHistory(response.data.data);
        }
      } catch (err) { }
  };
  const getEpisodePurchaseHistory = async () => {
    try {
      const response = await fetchCoinHistory(appInfo);
      if (response?.status === 200) {
      // Handle episode purchase history data if needed
        setCoinHistory(response.data.data);
      }
    } catch (err) { }
  };
  const getGiftHistory = async () => {
    try {
      const response = await fetchGiftHistory(appInfo);
      if (response?.status === 200) {
        setGiftHistory(response?.data);
      }
    } catch (err) { }
  };
  const updatePaymentDetails = async () => {
    const response = await getUpdatePaymentLink(appInfo);
    if (response.status === 200) {
      if (response.data?.url) {
        window.location.href = response.data.url;
      }
    }
  };

  if(loading) {
    return <Loading />
  }
  return (
    <div className="billingAndSubscription">
      <div className="wrapper">
        {subscriptionHistory?.purchase_history?.length > 0 && <div className="billingDetails">
          <h1 className="heading"><Translate textKey={'billing_details_title'} /></h1>
          <h6 className="subHeading"><Translate textKey={'your_membership'} /></h6>
          {subscriptionHistory?.last_purchase?.mode_of_payment !== 'Giftcard' && <div className="billingDetailsContainer">
            <div>
              <span className="head"><Translate textKey={'your_plan'} /></span>
              <span className="value bold">
                {subscriptionHistory?.last_purchase?.plan}
              </span>

              {expiryDate && (
                <>
                  <span className="head"><Translate textKey={'your_next_bill'} /></span>
                  <span className="value">{expiryDate}</span>
                </>
              )}
            </div>
            <div>
              {subscriptionHistory?.last_purchase?.mode_of_payment === "Stripe" && expiryDate && (
                <div className="billingButtonContainer" onClick={() => { updatePaymentDetails(); }}>
                  <div className="background" />
                  <button>
                    <Translate textKey={'update_payment_method'} />
                  </button>
                </div>
              )}
            </div>
          </div>}
        </div>}

        <div className="detailsSection">
          {(giftHistory?.data && giftHistory.data.length > 0) || projectInfo?.projectConfig?.config?.TOKEN_SUBSCRIPTION_REQUIRED === "true" ? (
            <>
              <div className="tabContainer">
                {subscriptionHistory?.purchase_history?.length > 0 && <div
                  className={`tab ${activeTab === "subscription" ? "active" : ""}`}
                  onClick={() => setActiveTab("subscription")}
                >
                  <Translate textKey={expiryDate ? 'subscription_details_title' : 'transaction_history'} />
                </div>}
                {projectInfo?.projectConfig?.config?.TOKEN_SUBSCRIPTION_REQUIRED === "true" && <div
                  className={`tab ${activeTab === "purchase_history" ? "active" : ""}`}
                  onClick={() => setActiveTab("purchase_history")}
                >
                  <Translate textKey={'transaction_history'} />
                </div>}
                {projectInfo?.projectConfig?.config?.TOKEN_SUBSCRIPTION_REQUIRED === "true" && <div
                  className={`tab ${activeTab === "coin_history" ? "active" : ""}`}
                  onClick={() => setActiveTab("coin_history")}
                >
                  <Translate textKey={'coin_history'} />
                </div>}
                {giftHistory?.data && giftHistory.data.length > 0 &&<div
                  className={`tab ${activeTab === "gift" ? "active" : ""}`}
                  onClick={() => setActiveTab("gift")}
                >
                  <Translate textKey={'gift_details'} />
                </div>}             
              </div>

              {activeTab === "subscription" && (
                <ul className="subscriptionContainer">
                  <li className="head">
                    <div className="left">
                      <div className="date"><Translate textKey={'date'} /></div>
                      <div className="transactionType"><Translate textKey={'transaction_type'} /></div>
                      <div className="servicePeriod"><Translate textKey={'service_period'} /></div>
                      <div className="paymentMethod"><Translate textKey={'payment_method'} /></div>
                      <div className="subscriptionName"><Translate textKey={'subscription_name'} /></div>
                    </div>
                    <div className="right">
                      <div className="total"><Translate textKey={'total'} /></div>
                    </div>
                  </li>
                  {subscriptionHistory?.purchase_history?.map((item, index) => (
                    <li key={index} className="body">
                      <div className="left">
                        <div className="date">{item?.date}</div>
                        <div className="transactionType">
                          {item?.transaction_type}
                        </div>
                        <div className="servicePeriod">{item?.service_period}</div>
                        <div className="paymentMethod">{item?.mode_of_payment}</div>
                        <div className="subscriptionName">
                          {item?.subscription_name}
                        </div>
                      </div>
                      <div className="right">
                        <div className="total">{item?.total}</div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}

              {activeTab === "gift" && (
                <ul className="subscriptionContainer">
                  <li className="head">
                    <div className="left">
                      <div className="date"><Translate textKey={'gift'} /></div>
                      <div className="transactionType"><Translate textKey={'status'} /></div>
                      <div className="servicePeriod"><Translate textKey={'purchased_by'} /></div>
                      <div className="paymentMethod"><Translate textKey={'recipient'} /></div>
                      {/* <div className="subscriptionName"><Translate textKey={'redemption_date'}/></div>
                      <div className="subscriptionName"><Translate textKey={'purchase_date'}/></div> */}
                    </div>
                    <div className="right">
                      <div className="total"><Translate textKey={'code'} /></div>
                    </div>
                  </li>
                  {giftHistory?.data?.map((item, index) => (
                    <li key={index} className="body">
                      <div className="left">
                        <div className="date">
                          <div>{item?.period} x {item?.plan_name}</div>
                        </div>
                        <div className="transactionType">
                          {item?.status}
                        </div>
                        <div className="servicePeriod">{item?.buyer_info}</div>
                        <div className="paymentMethod">{item?.recipient_info || "-"}</div>
                        {/* <div className="subscriptionName">{item?.redeemed_date ? new Date(item.redeemed_date).toLocaleDateString() : "-"}</div>
                        <div className="subscriptionName">{item?.purchase_date ? new Date(item.purchase_date).toLocaleDateString() : "-"}</div> */}
                      </div>
                      <div className="right">
                        <div className="total" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                          <span>{item?.giftcode}</span>
                          {item?.status !== 'REDEEMED' && item?.giftcode && (
                            <button
                              className={`copyGiftCodeBtn${copiedIndex === index ? ' copied' : ''}`}
                              onClick={() => handleCopy(item.giftcode, index)}
                              title={copiedIndex === index ? translateText('copied') : 'Copy claim URL'}
                              aria-label="Copy claim URL"
                              type="button"
                              style={{ marginLeft: 8 }}
                            >
                              <span className="icon-wrapper" style={{ position: 'relative', width: 20, height: 20, display: 'inline-block' }}>
                                <CopyIcon width={18} height={18} className={copiedIndex === index ? 'icon-hide' : 'icon-show'} style={{ position: 'absolute', left: 0, top: 0 }} />
                                <TickIcon width={18} height={18} className={copiedIndex === index ? 'icon-show' : 'icon-hide'} style={{ position: 'absolute', left: 0, top: 0 }} />
                              </span>
                            </button>
                          )}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}

              {activeTab === "purchase_history" && (
                <ul className="billingCoinHistoryContainer">
                  {(purchaseHistory && purchaseHistory.length > 0) ? purchaseHistory?.map((item, index) => (
                    <li className="billingCoinHistoryItem" key={`${item?.date || 'date'}-${item?.title || 'title'}-${index}`}>
                      <div className="billingCoinHistoryLeft">
                        <div className="billingCoinHistoryShow" title={item?.title || '-'}>{item?.title || '-'}</div>
                        <div className="billingCoinHistoryDate">{item?.date || '-'}</div>
                      </div>

                      <div className="billingCoinHistoryRight">
                        <span className="billingCoinHistoryAmount">{item.price}</span>
                      </div>
                    </li>
                  )) : <div className="noData"><Translate textKey={'no_data_found'} /></div>}
                </ul>
              )}

              {activeTab === "coin_history" && (
                <ul className="billingCoinHistoryContainer">
                  {(coinHistory && coinHistory.length > 0) ? coinHistory?.map((item, index) => {
                    return (
                      <li className="billingCoinHistoryItem" key={`${item?.usage_date || "usage"}-${index}`}>
                        <div className="billingCoinHistoryLeft">
                          <div className="billingCoinHistoryShow">{item?.transaction_type === "DEBIT" ? item?.show_name : item.bundle_name}</div>
                          {item?.episode_name && <div className="billingCoinHistoryEpisode">{item?.episode_name}</div>}
                          <div className="billingCoinHistoryDate">{item.usage_date}</div>
                        </div>

                        <div className="billingCoinHistoryRight">
                          <span className="billingCoinHistoryAmount">{item.tokens}</span>
                          {item?.token_symbol ? (
                            <img
                              className="billingCoinHistoryTokenIcon"
                              src={item?.token_symbol}
                              alt="coin icon"
                            />
                          ) : null}
                        </div>
                      </li>
                    );
                  }) : <div className="noData"><Translate textKey={'no_data_found'} /></div>}
                </ul>
              )}
            </>
          ) : (
            <>
              <h1 className="heading"><Translate textKey={expiryDate ? 'subscription_details_title' : 'transaction_history'} /></h1>
              <ul className="subscriptionContainer">
                <li className="head">
                  <div className="left">
                    <div className="date"><Translate textKey={'date'} /></div>
                    <div className="transactionType"><Translate textKey={'transaction_type'} /></div>
                    <div className="servicePeriod"><Translate textKey={'service_period'} /></div>
                    <div className="paymentMethod"><Translate textKey={'payment_method'} /></div>
                    <div className="subscriptionName"><Translate textKey={expiryDate ? 'subscription_name' : 'selected_plan_name'} /></div>
                  </div>
                  <div className="right">
                    <div className="total"><Translate textKey={'total'} /></div>
                  </div>
                </li>
                {subscriptionHistory?.purchase_history?.map((item, index) => (
                  <li key={index} className="body">
                    <div className="left">
                      <div className="date">{item?.date}</div>
                      <div className="transactionType">
                        {item?.transaction_type}
                      </div>
                      <div className="servicePeriod">{item?.service_period}</div>
                      <div className="paymentMethod">{item?.mode_of_payment}</div>
                      <div className="subscriptionName">
                        {item?.subscription_name}
                      </div>
                    </div>
                    <div className="right">
                      <div className="total">{item?.total}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>

        <div className="bottom">
          {activeTab !== "coin_history" && activeTab!== "purchase_history" && <p><Translate textKey={'note_billing_msg'} /></p>}
          {(subscriptionHistory?.last_purchase?.mode_of_payment === "Vizio" || subscriptionHistory?.last_purchase?.mode_of_payment === "vizio") && (
            <div className="vizio">
              <Translate textKey={'vizio_subscription_message'} /><span onClick={() => window.open('https://www.vizio.com/en/vizio-account', '_blank')}>https://www.vizio.com/en/vizio-account</span>.
            </div>
          )}
          <div className="buttonContainer" onClick={() => navigate("/account")}>
            <div className="background" />
            <button ><Translate textKey={'back'} /></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingDetails;
